exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".family-history .mainTitle{margin:13px 0}.family-history .mainTitle h4{margin:0;font-size:24px;font-weight:500}.family-history .MuiFormHelperText-root.Mui-error{font-size:13px;color:#f32e20}.family-history .radio-input .MuiFormHelperText-root.Mui-error{margin-left:29px;margin-top:-12px;padding-bottom:12px}.family-history .formElementTitle{font-size:.875rem;font-weight:500;line-height:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/FamilyHistory.scss
// module id = 7615
// module chunks = 13